import React from 'react'
import styled from 'styled-components'
import Grid from '@material-ui/core/Grid';
import TextField from 'components/TextField'
import FormSection from 'components/FormSection'
import { required, isEmail } from 'helpers/Validators'
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';
import ImageField from 'components/ImageField';
import InputLabel from '@material-ui/core/InputLabel';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const PictureIcon = styled(Icon)`
  font-size: 3rem;
`

const PersonalDetails = () => (
  <FormSection
    title={(
      <Typography variant="h6" component="h2">
        Informacje personalne 
      </Typography>
    )}
  >   
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
      <InputLabel shrink>
      Imię *
      </InputLabel>
        <TextField
          name="firstName"
          type="text"
          validate={required}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
      <InputLabel shrink>
      Nazwisko *
      </InputLabel>
        <TextField
          name="lastName"
          type="text"
          validate={required}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
      <InputLabel shrink>
      Telefon *
      </InputLabel>
        <TextField
          name="phone"
          type="phone"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
      <InputLabel shrink>
      Email *
      </InputLabel>
        <TextField
          name="email"
          type="email"
          validate={isEmail}
        />
      </Grid>     
      <Grid item xs={12} sm={12}>
        <ExpansionPanel >
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Pokaż dane dodatkowe</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            
              <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <InputLabel shrink>
                Kraj
                </InputLabel>
                  <TextField
                    name="country"
                    type="country"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                <InputLabel shrink>
                Miasto
                </InputLabel>
                  <TextField
                    name="city"
                    type="city"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                <InputLabel shrink>
                Adres zamieszkania
                </InputLabel>
                  <TextField
                    name="adress"
                    type="adress"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                <InputLabel shrink>
                Data urodzenia
                </InputLabel>
                  <TextField
                    name="birthday"
                    type="birthday"
                  />
                </Grid>
              </Grid>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </Grid> 
      <Grid item xs={12} sm={12}>
        <ImageField
          name="picture"
          type="text"
          label="First Name"
        >
          <img src={'http://www.aplikuj.pl/cv/kreator/zdjecie-profilowe.svg'}  />
        </ImageField>
      </Grid>
    </Grid>
  </FormSection>
)

export default PersonalDetails